<template>
	<div>
		<loading :active.sync="isLoading" :can-cancel="true" :is-full-page="true" :opacity="0"></loading>
		<router-view></router-view>
		<system-notice-host />
	</div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import SystemNoticeHost from '@/components/common/SystemNoticeHost.vue';

export default {
	components: {
		Loading,
		SystemNoticeHost,
	},
	computed: {
		isLoading() {
			return this.$store.getters['isLoading'];
		},
	},
};
</script>
